import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../../../common/commonService";
import { urlConstant } from "../../../constant/urlConstant";
import { ModalDirective } from "ngx-bootstrap/modal";
import { ToasterService } from "angular2-toaster";
import { Globals } from "../../../globals";
import { MatDialog } from "@angular/material";
import { ReceiptComponent } from "../receipt/receipt.component";
import { ImageShowModalComponent } from "../../../shared/image-slider/image-show-modal/image-show-modal.component";
import { ShareInfoComponent } from "../../../shared/share-to-user/share-info/share-info.component";
import Swal from "sweetalert2";
import { Location } from "@angular/common";
import { DomSanitizer } from "@angular/platform-browser";
import jsPDF from "jspdf";
@Component({
  selector: "app-proforma-invoice",
  templateUrl: "./proforma-invoice.component.html",
  styleUrls: ["./proforma-invoice.component.scss"],
})
export class ProformaInvoiceComponent implements OnInit {
  @ViewChild("viewBillModal", { static: false })
  public viewBillModal: ModalDirective;
  @ViewChild("pdfContentByInvoice", { static: false })
  pdfContentByInvoice: ElementRef;
  @ViewChild("pdfContentByReceipt", { static: false })
  pdfContentByReceipt: ElementRef;
  propertyId: any;
  receiptType: any;
  invoiceId: any;
  invoice: any = {};
  recepintList: any[] = [];
  billTypeList: any[] = [];
  selectedRecepint = new FormControl("");
  userDetail: any = {};
  showUserEdit: boolean = false;
  showEdit: Boolean = true;
  showSave: Boolean = false;
  loginUserDetail: any;
  propertyData: any = {};
  otherFirstName = new FormControl("");
  otherLastName = new FormControl("");
  otherNumber = new FormControl("");
  otherEmail = new FormControl("");
  otherAddress = new FormControl("");
  otherGst = new FormControl("");

  invoiceDescription = new FormControl("");
  invoiceDueDate = new FormControl("");
  generatedBy = new FormControl("");

  billDetails: any[] = [];
  billDetailsBackup: any[] = [];
  formatStartDate: any;
  formatEndDate: any;
  startDate: any;
  endDate: any;
  checkedData: any[] = [];
  showButton: boolean = false;
  checked: boolean = false;
  minSelectedDate: string;
  minDate: Date;
  endFormattedDate: string;
  invoiceForm: FormGroup;
  subTotal: number = 0;
  cgstPercentage: number = 0;
  totalCgstAmount: number = 0;
  sgstPercentage: number = 0;
  totalSgstAmount: number = 0;
  totalDiscountAmount: number = 0;
  grandSubTotal: number = 0;
  discountPercentage: number = 0;
  dPercentage = new FormControl("");
  sPercentage = new FormControl("");
  cPercentage = new FormControl("");
  showBankEdit: Boolean = true;
  showBankSave: Boolean = false;
  bankSavedData: any = {};
  bankAccount = new FormControl("");
  bankBranch = new FormControl("");
  bankHolder = new FormControl("");
  bankIfsc = new FormControl("");
  bankName = new FormControl("");
  itemList: any[] = [];
  itemNotes = new FormControl("");
  payToId: any;
  company: any = {
    companyName: "",
    addressLine1: "",
    addressLine2: "",
    state: "",
    pincode: "",
    gstNumber: "",
    phoneNumber: "",
    email: "",
    companyLogoImage: "",
  };
  section: any;
  openUrlId: any;
  openView: boolean = false;
  sahredUserDetail: any = {};
  showGstInput: boolean = false;
  invoiceGst = new FormControl("");
  show: boolean = false;
  companyLogo: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _CommonService: CommonService,
    private toatserService: ToasterService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private location: Location,
    public sanitizer: DomSanitizer
  ) {
    if (this.location.path().includes("action") === true) {
      this.openView = true;
      this.openUrlId = this.route.snapshot.params.id;
      this.getReceiptType(this.openUrlId);
    } else {
      if (String(this.route.snapshot.params.id).split("_").length > 1) {
        this.propertyId = this.route.snapshot.params.id.split("_")[0];
        this.receiptType = this.route.snapshot.params.id.split("_")[1];
        this.invoiceId = this.route.snapshot.params.id.split("_")[2];

        this.getInvoiceByInvoiceId(this.invoiceId);
      }
    }
  }
  getReceiptType(openUrlId: any) {
    this._CommonService
      .get<any>(
        urlConstant.ProformaInvoice.getProformaInvoiceOpenUrlData +
          `?sharedId=${openUrlId}`
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          if (!!res.data.ProformaInvoiceOpenUrl) {
            this.receiptType = res.data.ProformaInvoiceOpenUrl.type;
          }
        }
      });
  }

  ngOnInit(): void {
    console.log("Invoice ID:", this.route.snapshot.paramMap.get("id"));
    console.log("Receipt Type:", this.receiptType);
    console.log("Company Data:", this.company);
    this.getPropertyByPropertyId();
  }

  previous() {
    this.router.navigateByUrl(
      `/admin/invoice-performa/add-view-invoice/${this.propertyId}`
    );
  }

  getInvoiceByInvoiceId(invoiceId: any) {
    this._CommonService
      .get<any>(
        urlConstant.ProformaInvoice.getProformaInvoiceByInvoiceId +
          "?proformainvoiceId=" +
          invoiceId
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.invoice = res.data.Invoice;
          // this.bankSavedData = this.invoice.bankInfo;
          // this.selectedRecepint.setValue(this.invoice.selecteReceipnt)
          //  this.onChangeRecepint();
          // this.patchValuesToDescription(this.invoice);
          this.getCompanyDetails();
        }
      });
  }

  // getParamMaster() {
  //   this._CommonService.get<any>(urlConstant.Invoice.getParamMasterForInvoice).subscribe((res: any) => {
  //     this.recepintList = res.data.recepintList;
  //     this.billTypeList = res.data.billTypeList;
  //   })
  // }

  // onChangeRecepint() {
  //   this.invoice.userList.filter((ele: any) => String(ele.roleName).toLowerCase() === String(this.selectedRecepint.value).toLowerCase()).map((val: any) => {
  //     this.userDetail = val;

  //   })
  //   let recList = [];
  //   recList = this.recepintList.filter((ele: any) => String(ele.paramValue).toLowerCase() === String(this.selectedRecepint.value).toLowerCase()).map(val => val);
  //   if (recList !== undefined && recList.length > 0) {
  //     recList.map(val => this.payToId = val.id);
  //   }
  // }

  getPropertyByPropertyId() {
    this._CommonService
      .get<any>(
        urlConstant.Property.GetPropertyByPropertyId +
          "?propertyId=" +
          this.propertyId
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.propertyData = res.data.Property;
        }
      });
  }

  // editInvoice(invoice: any) {
  //   this.showEdit = false;
  //   this.showSave = true;
  //   this.invoiceDescription.setValue(invoice.description !== null ? invoice.description : "");
  //   this.invoiceDueDate.setValue(invoice.dueDate !== null ? invoice.dueDate.split('T')[0] : "");
  //   this.generatedBy.setValue(invoice.generatedBy !== null ? invoice.generatedBy : String(this.loginUserDetail.firstName) + " " + String(this.loginUserDetail.lastName));
  // }

  // saveInvoice() {
  //   let invoiceDetailObj = {
  //     invoiceId: this.invoiceId,
  //     invoiceDescription: this.invoiceDescription.value,
  //     dueDate: new Date(this.invoiceDueDate.value).toISOString().split('T')[0],
  //     generatedBy: this.generatedBy.value,
  //   }
  //   this._CommonService.showLoading();
  //   this._CommonService.post(urlConstant.Invoice.saveInvoiceDetail, invoiceDetailObj).subscribe((res: any) => {
  //     if (res.Status === "200") {
  //       this.invoice = res.data.Invoice;
  //       this.toatserService.pop('success', 'Success', res.message);
  //       this.showEdit = true;
  //       this.showSave = false;
  //       this._CommonService.hideLoading();
  //     } else {
  //       this.toatserService.pop('error', 'Error', res.message);
  //       this._CommonService.hideLoading();
  //     }
  //   })
  // }

  // existingBill() {
  //   this.checkedData = [];
  //   this.showButton = false;
  //   this.checked = false;
  //   this.billDetails.map(x => {
  //     x.checked = false;
  //   })
  //   this.viewBillModal.show();
  // }

  // serachByDate() {
  //   this.getFilterDateData();
  // }

  // getFilterDateData() {
  //   this.billDetails = this.billDetailsBackup.filter(ele => ele.billDueDate >= this.formatStartDate && ele.billDueDate <= this.formatEndDate).map(val => val);
  // }

  // clearDateFilter() {
  //   this.startDate = undefined;
  //   this.endDate = undefined;
  //   this.formatStartDate = undefined;
  //   this.formatEndDate = undefined
  //   this.billDetails = this.billDetailsBackup;
  // }

  // selectAll(event) {
  //   this.billDetails.map((val: any) => {
  //     if (event === true) {
  //       val.checked = true;
  //       this.checked = true;
  //       this.showButton = true;
  //       this.checkedData.push(val);
  //     } else {
  //       val.checked = false;
  //       this.checked = false;
  //       this.showButton = false;
  //       this.checkedData = [];
  //     }
  //   });
  // }

  // selectIndiviual(event, data) {
  //   this.checked = false;
  //   if (event === true) {
  //     if (this.checkedData.length === 0) {
  //       this.checkedData.push(data);
  //       this.showButton = true;
  //     } else {
  //       const isFound = this.checkedData.some(ele => {
  //         if (ele.billId === data.billId) {
  //           return true;
  //         } else {
  //           return false;
  //         }
  //       })

  //       if (isFound === false) {
  //         this.checkedData.push(data)
  //         if (this.checkedData.length > 0) {
  //           this.showButton = true;
  //         }
  //       }
  //     }
  //   } else {
  //     let index = this.checkedData.findIndex((ind) => {
  //       if (ind.billId === data.billId) {
  //         return ind;
  //       }
  //     })
  //     if (index !== -1) {
  //       this.checkedData.splice(index, 1)
  //     }
  //     if (this.checkedData.length === 0) {
  //       this.showButton = false;
  //     }
  //   }
  // }

  // minDateChageEvent(event) {
  //   this.formatStartDate = Globals.defaultDateFormat(this.startDate)
  //   this.minSelectedDate = Globals.defaultDateFormat(Globals.convertToIST(event.value['_d']));
  //   this.minDate = new Date(this.minSelectedDate);
  // }
  // maxDateChageEvent(event) {
  //   this.formatEndDate = Globals.defaultDateFormat(this.endDate)
  //   this.endFormattedDate = Globals.defaultDateFormat(Globals.convertToIST(event.value['_d']));
  // }

  // calculateValues() {
  //   this.subTotal = 0;
  //   this.fields.value.map((val: any) => {
  //     this.subTotal = Number(Number(this.subTotal) + Number(val.totalAmount));
  //   });
  //   this.grandTotal();
  // }

  // handleCgstChange(event: any) {
  //   this.cgstPercentage = Number(event.target.value)
  //   this.totalCgstAmount = this.getGstAmount(event.target.value);
  //   this.grandTotal();
  // }

  // handleSgstChange(event: any) {
  //   this.sgstPercentage = Number(event.target.value)
  //   this.totalSgstAmount = this.getGstAmount(event.target.value);
  //   this.grandTotal();
  // }

  // handleCgstkeyup(event: any) {
  //   this.cgstPercentage = Number(event.target.value)
  //   this.totalCgstAmount = this.getGstAmount(event.target.value);
  //   this.grandTotal();
  // }

  // handleSgstkeyup(event: any) {
  //   this.sgstPercentage = Number(event.target.value)
  //   this.totalSgstAmount = this.getGstAmount(event.target.value);
  //   this.grandTotal();
  // }

  // grandTotal() {
  //   let grandSubTotal = Number(Number(this.subTotal) + Number(this.totalCgstAmount) + Number(this.totalSgstAmount));

  //   if (this.totalDiscountAmount !== null && this.totalDiscountAmount !== 0) {
  //     this.grandSubTotal = Number(Number(grandSubTotal) - Number(this.totalDiscountAmount));
  //   } else {
  //     this.grandSubTotal = Number(grandSubTotal);
  //   }
  // }

  // getGstAmount(value: any): number {
  //   return Number(Number(Number(value / 100) * Number(this.subTotal)).toFixed(2));
  // }

  // getGstPercentAmount(value: any): number {
  //   return Number(Number(Number(value / 100) * Number(this.subTotal)).toFixed(2));
  // }

  // handleDiscountkeyup(event: any) {
  //   this.discountPercentage = Number(event.target.value)
  //   this.totalDiscountAmount = this.gesDiscountAmount(event.target.value);
  //   this.grandTotal();
  // }

  // handleDiscountChange(event: any) {
  //   this.discountPercentage = Number(event.target.value)
  //   this.totalDiscountAmount = this.gesDiscountAmount(event.target.value);
  //   this.grandTotal();
  // }

  // gesDiscountAmount(value: any): number {
  //   return Number(Number(value / 100) * Number(this.subTotal));
  // }

  // patchTotalAmountByUnitAmount(fieldIndex: any) {
  //   if (this.fields.at(fieldIndex).get("quantity").value !== null && this.fields.at(fieldIndex).get("quantity").value !== undefined) {
  //     this.fields.at(fieldIndex).get("totalAmount").patchValue(String(Number(this.fields.at(fieldIndex).get("unitAmount").value) * Number(this.fields.at(fieldIndex).get("quantity").value)));
  //   } else {
  //     this.fields.at(fieldIndex).get("totalAmount").patchValue(String(this.fields.at(fieldIndex).get("unitAmount").value))
  //   }
  //   this.calculateValues();
  //   this.onChangeUnitAndQtyTaxValues();
  // }

  // patchTotalAmountByQuantity(fieldIndex: any) {
  //   this.fields.at(fieldIndex).get("totalAmount").patchValue(String(Number(this.fields.at(fieldIndex).get("unitAmount").value) * Number(this.fields.at(fieldIndex).get("quantity").value)));
  //   this.calculateValues();
  //   this.onChangeUnitAndQtyTaxValues();
  // }

  // handleQtyChange(fieldIndex: any) {
  //   this.fields.at(fieldIndex).get("totalAmount").patchValue(String(Number(this.fields.at(fieldIndex).get("unitAmount").value) * Number(this.fields.at(fieldIndex).get("quantity").value)));
  //   this.calculateValues();
  //   this.onChangeUnitAndQtyTaxValues()
  // }

  // handleUnitAmountChange(fieldIndex: any) {
  //   if (this.fields.at(fieldIndex).get("quantity").value !== null && this.fields.at(fieldIndex).get("quantity").value !== undefined) {
  //     this.fields.at(fieldIndex).get("totalAmount").patchValue(String(Number(this.fields.at(fieldIndex).get("unitAmount").value) * Number(this.fields.at(fieldIndex).get("quantity").value)));
  //   } else {
  //     this.fields.at(fieldIndex).get("totalAmount").patchValue(String(this.fields.at(fieldIndex).get("unitAmount").value))
  //   }
  //   this.calculateValues();
  //   this.onChangeUnitAndQtyTaxValues();
  // }

  // onChangeUnitAndQtyTaxValues() {
  //   this.totalDiscountAmount = this.gesDiscountAmount(this.dPercentage.value);
  //   this.totalSgstAmount = this.getGstAmount(this.sPercentage.value);
  //   this.totalCgstAmount = this.getGstAmount(this.cPercentage.value);
  //   this.grandTotal();
  // }

  // getUserBankDetails() {
  //   this._CommonService.get<any>(urlConstant.Invoice.getUserBankAccount + '?invoiceId=' + this.invoiceId).subscribe((res: any) => {
  //     if (res.Status === '200') {
  //       this.bankSavedData = res.data.Bank
  //     }
  //   })
  // }

  // patchValuesToDescription(invoice: any) {
  //   invoice.invoiceDetailList.map((data: any, index: any) => {
  //     this.fields.push(this.formBuilder.group({
  //       itemType: new FormControl(data.type),
  //       itemName: new FormControl(data.name),
  //       itemDescription: new FormControl(data.itemDescription),
  //       unitAmount: new FormControl(data.unitAmount),
  //       quantity: new FormControl(data.quantity),
  //       totalAmount: new FormControl(Number(data.itemTotalAmount)),
  //       showInvoiceSave: new FormControl(true),
  //       showDropDown: new FormControl(false),
  //       identityId: new FormControl(data.identityId),
  //       invoiceDetailId: new FormControl(data.id),
  //       hsnSsc: new FormControl(data.hsnSsc)
  //     }));
  //   })

  //   this.itemNotes.patchValue(invoice.notes);
  //   this.subTotal = this.invoice.subTotal;
  //   this.cPercentage.setValue(invoice.cgstPercentage);
  //   this.sPercentage.setValue(invoice.sgstPercentage);
  //   this.dPercentage.setValue(invoice.discountPercentage);
  //   this.totalCgstAmount = invoice.cgstAmount;
  //   this.totalSgstAmount = invoice.sgstAmount;
  //   this.totalDiscountAmount = invoice.discountAmount;
  //   this.grandSubTotal = invoice.grandTotal;
  //   this._CommonService.hideLoading();
  // }

  shareInvoice(receiptType: any) {
    if (this.company !== null) {
      const dialogRef = this.dialog.open(ShareInfoComponent, {
        width: "450px",
        height: "auto",
        autoFocus: false,
        hasBackdrop: true,
        data: {
          invoiceId: this.invoiceId,
          type: "Receipt",
          receiptType: receiptType,
          userDetailList: this.invoice.userList,
          propertyData: this.propertyData,
        },
      });

      dialogRef.afterOpened().subscribe(() => {
        const overlay = document.querySelector(".cdk-overlay-backdrop");
        if (overlay) {
          overlay.addEventListener("click", () => {
            dialogRef.close(); // Close the dialog when overlay is clicked
          });
        }
      });

      dialogRef.afterClosed().subscribe((result) => {});
    } else {
      Swal.fire({
        title: "Company Detail Missing!",
        html: "Please Add Comapny Detail at Profile Section",
        icon: "warning",
        showCloseButton: true,
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "NO",
      }).then((result) => {
        if (result.isConfirmed) {
        }
      });
    }
  }

  // showTempLigthBox() {
  //   const dialogRef = this.dialog.open(ImageShowModalComponent, {
  //     width: '800px',
  //     data: {
  //       attachment: this.invoice.imageList,
  //       index: 0
  //     },
  //     backdropClass: 'custom-backdrop-class', // Custom CSS class for the backdrop
  //     hasBackdrop: true,
  //   });

  //   dialogRef.afterOpened().subscribe(() => {
  //     const overlay = document.querySelector('.cdk-overlay-backdrop');

  //     if (overlay) {
  //       overlay.addEventListener('click', () => {
  //         dialogRef.close(); // Close the dialog when overlay is clicked
  //       });
  //     }
  //   });

  //   dialogRef.afterClosed().subscribe(result => { });
  // }

  // getInvoiceOpenUrl() {
  //   this._CommonService.get<any>(urlConstant.Auth.getInvoiceOpenUrl + "?sharedId=" + this.openUrlId).subscribe((res: any) => {
  //     if (res.Status === '200') {
  //       this.invoice = res.data.Invoice;
  //       this.propertyData = res.data.Property;
  //       this.company = res.data.CompanyDetail;
  //       this.sahredUserDetail = res.data.SharedBy;
  //       this.getBillTo(res.data.Invoice);
  //       this.patchValuesToDescription(this.invoice);
  //       this.receiptType = "rec";
  //     } else {
  //       this.toatserService.pop('error', 'Error', res.message);
  //     }
  //   })
  // }

  // getBillTo(invoice: any) {
  //   this.selectedRecepint.setValue(invoice.selecteReceipnt);
  //   invoice.userList.map((ele: any) => {
  //     if (String(ele.roleName).toLowerCase() === String(invoice.selecteReceipnt).toLowerCase()) {
  //       this.userDetail = ele;
  //     }
  //   })
  //   this.bankSavedData = invoice.bankInfo;
  // }

  getCompanyDetails() {
    this._CommonService.get<any>(urlConstant.Auth.getCompanyDetail).subscribe(
      (res: any) => {
        if (res.Status === "200" && res.data && res.data.CompanyDetail) {
          this.company = res.data.CompanyDetail;
          if (this.company.imageExtension) {
            this.companyLogo =
              "data:image/" +
              this.company.imageExtension.toLowerCase() +
              ";base64," +
              this.company.imageBase64;
          }
        } else {
          this.company = null;
        }
        console.log(this.company, "ddd");
      },
      (error) => {
        if (error != null) {
          console.error("error", "Error", error.message);
        }
      }
    );
  }

  formatIndianNumerationWithDecimals(number: number): string {
    return number !== null && number !== undefined
      ? number.toLocaleString("en-IN", { maximumFractionDigits: 2 })
      : "0";
  }

  editGst(userDetail: any) {
    this.showGstInput = true;
  }

  saveGst(userDetail: any) {
    let gstObj = {
      proformaInvoiceId: this.invoiceId,
      gst: this.invoiceGst.value,
      roleId: userDetail.roleId,
    };
    this._CommonService
      .post(urlConstant.ProformaInvoice.addGstForUsersAtProformaInvoice, gstObj)
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.showGstInput = false;
          this.toatserService.pop("success", "Success", res.message);
        } else {
          this.showGstInput = false;
          this.toatserService.pop("error", "Error", res.message);
        }
      });
  }

  download() {
    this._CommonService.showLoading();
    const nes = [this.pdfContentByInvoice.nativeElement];
    let nativeElement = nes[0];
    Array.from(nativeElement.querySelectorAll(".search-input")).map(
      (e: any) => {
        e.classList.add("d-none");
      }
    );

    Array.from(nativeElement.querySelectorAll(".icon-display")).map(
      (e: any) => {
        e.classList.add("d-none");
      }
    );
    Array.from(nativeElement.querySelectorAll(".bill-display")).map(
      (e: any) => {
        e.classList.add("d-none");
      }
    );

    Array.from(nativeElement.querySelectorAll(".pdf-display ")).map(
      (e: any) => {
        e.classList.remove("d-none");
      }
    );

    Array.from(nativeElement.querySelectorAll(".action-display")).map(
      (e: any) => {
        e.classList.add("d-none");
      }
    );

    Array.from(nativeElement.querySelectorAll(".table")).map((e: any) => {
      e.classList.remove("table-striped");
    });

    Array.from(nativeElement.querySelectorAll(".gst-box")).map((e: any) => {
      e.classList.remove("d-flex");
      e.classList.add("d-none");
    });

    Array.from(nativeElement.querySelectorAll(".gst-display")).map((e: any) => {
      e.classList.remove("d-none");
    });

    Array.from(nativeElement.querySelectorAll(".app-pdf-company-preview")).map(
      (e: any) => {
        e.classList.remove("d-none");
      }
    );
    // Wait for images to load
    setTimeout(() => {
      this.generateInvoicetPDF(nativeElement);
    }, 1000);
  }

  generateInvoicetPDF(nativeElement: any) {
    let doc = new jsPDF();
    doc.html(nativeElement, {
      callback: () => {
        this._CommonService.hideLoading();
        doc.save(`INVOICE_DETAIL(${this.invoice.proformainvoiceNo}).pdf`);
        Array.from(nativeElement.querySelectorAll(".search-input ")).map(
          (e: any) => {
            e.classList.remove("d-none");
          }
        );
        Array.from(nativeElement.querySelectorAll(".icon-display")).map(
          (e: any) => {
            e.classList.remove("d-none");
          }
        );

        Array.from(nativeElement.querySelectorAll(".bill-display")).map(
          (e: any) => {
            e.classList.remove("d-none");
          }
        );

        Array.from(nativeElement.querySelectorAll(".pdf-display ")).map(
          (e: any) => {
            e.classList.add("d-none");
          }
        );
        Array.from(nativeElement.querySelectorAll(".action-display")).map(
          (e: any) => {
            e.classList.remove("d-none");
          }
        );
        Array.from(nativeElement.querySelectorAll(".table")).map((e: any) => {
          e.classList.add("table-striped");
        });
        Array.from(nativeElement.querySelectorAll(".gst-box")).map((e: any) => {
          e.classList.add("d-flex");
          e.classList.remove("d-none");
        });

        Array.from(nativeElement.querySelectorAll(".gst-display")).map(
          (e: any) => {
            e.classList.add("d-none");
          }
        );

        Array.from(
          nativeElement.querySelectorAll(".app-pdf-company-preview")
        ).map((e: any) => {
          e.classList.add("d-none");
        });
      },
      windowWidth: nativeElement.getBoundingClientRect().width,
      width: 190,
      margin: [10, 10, 10, 10],
      autoPaging: "text",
      image: { type: "webp", quality: 0.98 }, // as per req
      html2canvas: { letterRendering: false, useCORS: true },
    });
  }

  downloadReceipt() {
    this._CommonService.showLoading();

    const nes = [this.pdfContentByReceipt.nativeElement];
    let nativeElement = nes[0];
    Array.from(nativeElement.querySelectorAll(".table")).map((e: any) => {
      e.classList.remove("table-striped");
    });

    Array.from(nativeElement.querySelectorAll(".action-display")).map(
      (e: any) => {
        e.classList.add("d-none");
      }
    );

    Array.from(nativeElement.querySelectorAll(".app-pdf-company-preview")).map(
      (e: any) => {
        e.classList.remove("d-none");
      }
    );

    // Wait for images to load
    setTimeout(() => {
      this.generateReceiptPDF(nativeElement);
    }, 1000);
  }

  generateReceiptPDF(nativeElement: HTMLElement) {
    let doc = new jsPDF();
    doc.html(nativeElement, {
      callback: () => {
        this._CommonService.hideLoading();
        doc.save(`INVOICE_RECEIPT(${this.invoice.proformainvoiceNo}).pdf`);

        Array.from(nativeElement.querySelectorAll(".table")).map((e: any) => {
          e.classList.add("table-striped");
        });

        Array.from(nativeElement.querySelectorAll(".action-display")).map(
          (e: any) => {
            e.classList.remove("d-none");
          }
        );

        Array.from(
          nativeElement.querySelectorAll(".app-pdf-company-preview")
        ).map((e: any) => {
          e.classList.add("d-none");
        });
      },
      windowWidth: nativeElement.getBoundingClientRect().width,
      width: 190,
      margin: [10, 10, 10, 10],
      autoPaging: "text",
      image: { type: "webp", quality: 0.98 }, // as per req
      html2canvas: { letterRendering: true, useCORS: true },
    });
  }

  getEmail(email: any) {
    return !!email ? email.replace(/\s/g, "") : "............";
  }
}
